<div *ngIf="literalesCargados"
     id="contenedor">
  <router-outlet></router-outlet>
</div>